"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwapServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
class SwapServiceLive {
    getSwapOffers(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/swap-offers`);
            return response.data;
        });
    }
    getMySwapOffers(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/swap-offers/my-offers`);
            return response.data;
        });
    }
    getPendingApprovalSwapOffers(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/swap-offers/pending-approval`);
            return response.data;
        });
    }
    createSwapOffer(companyId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/swap-offers`, data);
            return response.data;
        });
    }
    cancelSwapOffer(companyId, swapOfferId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/swap-offers/cancel`, { swapOfferId });
            return response.data;
        });
    }
    acceptSwapOffer(companyId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/swap-offers/accept`, data);
            return response.data;
        });
    }
    approveSwapOffer(companyId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/swap-offers/approve`, data);
            return response.data;
        });
    }
    rejectSwapOffer(companyId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/swap-offers/reject`, data);
            return response.data;
        });
    }
    getActiveSwapWindow(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/swap-windows/active`);
            return response.data;
        });
    }
    getSwapWindows(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/swap-windows`);
            return response.data;
        });
    }
    createSwapWindow(companyId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/swap-windows`, data);
            return response.data;
        });
    }
    updateSwapWindowStatus(companyId, swapWindowId, status) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/swap-windows/${swapWindowId}/status/${status}`, {});
            return response.data;
        });
    }
}
exports.SwapServiceLive = SwapServiceLive;
//# sourceMappingURL=SwapServiceLive.js.map